// @ts-nocheck
import { useQuery } from '@apollo/client';
import GET_COURSE_AGENDA from '../graphql/getCourseAgenda.graphql';
import { CourseAgendaTypes } from './types';

const useCourseAgenda = (isPt: boolean) => {
  const {
    data,
    loading: loadingAgenda,
    error: errorAgenda,
    refetch: refetchAgenda,
  } = useQuery<CourseAgendaTypes>(GET_COURSE_AGENDA, {
    variables: {
      identifier: isPt ? 'remote-work-pt' : 'remote-work-es',
    },
  });

  const courses =
    data && data.courseScheduleDetail
      ? data.courseScheduleDetail.edges.map(el => {
          return {
            dateSchedule: el.node.dateSchedule,
            isSubscribe: el.node.isSubscribe,
            ...el.node.course,
          };
        })
      : [];

  return {
    courses,
    loadingAgenda,
    errorAgenda,
    refetchAgenda,
  };
};

export default useCourseAgenda;
